<template>
  <div id="app">
    <nav-bar />
    <router-view class="main_content" />
  </div>
</template>

<script>
import NavBar from "@/components/Nav.vue";

export default {
  components: {
    navBar: NavBar,
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/vendors/bootstrap-vue/index";
@import "assets/css/style.css";
</style>
